var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 101.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-login") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.58,79.83,85.4,95.56l1,6.38,6.33-1L92,96.11l5.24-.85L96.38,90l5-.82.68-5a14.88,14.88,0,0,0,8.54,1.12A14,14,0,1,0,94,73.87a13.4,13.4,0,0,0,2.54,6ZM40.06,54.9c.28-2.41-6.86-9.52-8.16-13.92-2.79-4.46-3.79-11.52-.74-16.22,1.22-1.87.69-3,.69-5.57,0-25.58,44.83-25.59,44.83,0,0,3.24-.75,3.5,1,6,2.94,4.25,1.42,11.78-1,15.74-1.59,4.63-9.09,11.29-8.56,13.92.44,13.14-28.11,12.69-28,0ZM0,90c1.21-15.69-1.87-11.87,11.27-16.8,6.56-2.46,14.94-5.58,21-9.33L43.51,90ZM56.38,77.61H58A2.59,2.59,0,0,0,60.53,75V70.84A2.59,2.59,0,0,0,58,68.26H48.61A2.59,2.59,0,0,0,46,70.84V75a2.59,2.59,0,0,0,2.58,2.58H50.2L47.15,90H59.32L56.38,77.61ZM74.83,62.55a59.8,59.8,0,0,0,8.54,4.38,24.43,24.43,0,0,0,.56,11.78l-7.46,10.5c-.19.27-.37.54-.54.82H63.19L74.83,62.55Zm34.88,4.22a2.59,2.59,0,1,0,3,2.15,2.6,2.6,0,0,0-3-2.15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogin);
export default __webpack_public_path__ + "static/media/userLogin.2488a42f.svg";
export { ForwardRef as ReactComponent };